module.exports = __webpack_public_path__ + "static/img/person-subscribe.bd36438.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/person-subscribe.png
// module id = jWkP
// module chunks = 1